import { Box, Button, Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { KeyGate } from '@/crypto/KeyGate'
import { lock, useKeystore } from '@/crypto/keystore'
import NiLock from '@/ui/icons/nexture/ni-lock'
import NiShieldCheck from '@/ui/icons/nexture/ni-shield-check'
import { Panel } from '@/ui/kit/Panel'

/**
 * Chave e recuperação.
 *
 * A seção da chave mora aqui porque é o único lugar onde criar, destravar e
 * trancar são decisão consciente, e não algo que acontece de passagem. O
 * `KeyGate` faz o trabalho: sem chave ele mostra o setup, com a chave
 * fechada mostra a tela de destravar.
 */

function ChaveAberta() {
  const { epoch } = useKeystore()
  return (
    <Box data-testid="chave-aberta" className="flex max-w-prose flex-col gap-4">
      <Box className="flex items-center gap-3">
        <Box className="bg-success/10 text-success-ink flex h-11 w-11 shrink-0 items-center justify-center rounded-xl">
          <NiShieldCheck size="medium" />
        </Box>
        <Box>
          <Typography variant="subtitle1" component="p">
            A chave está aberta neste navegador
          </Typography>
          <Typography variant="body2" className="text-text-secondary">
            Fica guardada neste computador até você trancar aqui ou sair da conta. Trancas nesta
            aba: <span className="tabular-nums">{epoch}</span>.
          </Typography>
        </Box>
      </Box>
      <Button
        data-testid="trancar"
        variant="outlined"
        color="grey"
        startIcon={<NiLock size="medium" />}
        className="self-start"
        onClick={() => lock()}
      >
        Trancar agora
      </Button>
    </Box>
  )
}

export const Route = createFileRoute('/_app/app/config/')({
  component: function Chave() {
    return (
      <Panel subtitle="A chave que abre os registros fica neste navegador. O servidor guarda só os embrulhos.">
        <KeyGate inline>
          <ChaveAberta />
        </KeyGate>
      </Panel>
    )
  },
})
